/**
 * Illustrative funder pricing for the homepage OfferEstimator.
 *
 * ⚠️  THESE RATES ARE PLACEHOLDERS, NOT REAL TERMS.
 *
 * They exist so the estimator can demonstrate the one thing that makes a
 * marketplace worth using — that four funders pricing the same case do not
 * arrive at the same number. Every figure the estimator renders is labelled as
 * an illustration in the UI.
 *
 * Replacing them before launch is a one-file change: swap the rates below,
 * adjust CAP if the real agreements differ, and nothing else moves. Anything
 * touching these numbers needs human sign-off — see the "needs a human before
 * launch" list in docs/redesign/HANDOFF.md.
 *
 * Kept free of React so it stays plain, inspectable data like the rest of
 * src/data.
 */

/** Simple (non-compounding) annual rate applied to the advance. */
export const FUNDER_RATES = [
  { name: 'Funder A', rate: 0.24 },
  { name: 'Funder B', rate: 0.278 },
  { name: 'Funder C', rate: 0.315 },
  { name: 'Funder D', rate: 0.36 },
];

/** Repayment never exceeds this multiple of the advance. */
export const REPAYMENT_CAP = 2;

/** Amount the estimator opens on, and the bounds a typed amount is held to. */
export const DEFAULT_AMOUNT = 5000;
export const MIN_AMOUNT = 0;
export const MAX_AMOUNT = 250000;

/** Quick-pick chips, in the order they render. */
export const AMOUNT_PRESETS = [1000, 2500, 5000, 10000, 25000];

/** Months-to-settlement slider bounds and starting position. */
export const DEFAULT_MONTHS = 18;
export const MIN_MONTHS = 3;
export const MAX_MONTHS = 48;

/**
 * What a plaintiff repays: simple interest over the elapsed months, held to
 * REPAYMENT_CAP× the advance. Interest accrues on the starting balance only —
 * never on interest already accrued.
 */
export function payoff(principal, rate, months) {
  return Math.min(principal * (1 + rate * (months / 12)), principal * REPAYMENT_CAP);
}
